import React from 'react';

export function useScrollToFormOnce() {
  const once = React.useRef(false);
  const scrollTargetRef = React.useRef<HTMLSpanElement | null>(null);

  const onFocus = React.useCallback((e: React.FocusEvent<HTMLFormElement>) => {
    if (!once.current) {
      once.current = true;
      scrollTargetRef.current?.scrollIntoView();
    }
  }, []);

  return {
    onFocus,
    scrollTargetRef,
  } as const;
}
